<template>
	<v-container>
		<v-layout row justify-center>
			<v-flex sm12 md10>
				<v-alert type="success" v-if="showSuccess">
					You successfully deleted {{ name }}!<v-btn text v-on:click="refresh()"
						><v-icon class="font-weight-light">close</v-icon></v-btn
					></v-alert
				>
				<v-alert type="warning" v-if="showError"> {{ error }}</v-alert>
				<v-container>
					<h3 style="text-align:center;" class="pa-3">Delete</h3>
					<v-select
						class="pa-3"
						outlined
						:items="eventList"
						label="Select a Event-Class Section"
						v-model="eventID"
						@input="getDocs()"
					></v-select>
					<v-select
						v-if="show"
						class="pa-3"
						outlined
						:items="docsList"
						label="Select the Event-Class to Delete"
						v-model="name"
					></v-select>
					<v-btn v-if="show" v-on:click="deleter()" block dark>Delete</v-btn>
				</v-container>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import fb from "@/fb";
import { Events } from "@/Models/Events";
import _ from "lodash";
export default {
	data() {
		return {
			eventList: _.map(Events, "id"),
			eventID: "",
			docsList: [],
			show: false,
			name: "",
			showError: false,
			showSuccess: false,
			error: "",
			id: "",
			emails: [],
			userids: [],
		};
	},
	methods: {
		refresh() {
			window.location.reload();
		},
		getDocs() {
			this.docsList = [];
			fb.db
				.collection("Events")
				.where("location.id", "==", this.eventID)
				.get()
				.then((snapshot) => {
					snapshot.docs.forEach((doc) => {
						this.docsList.push(
							doc.data().title + "//" + doc.data().date + "//" + doc.id
						);
						this.show = true;
					});
				});
		},
		async deleter() {
			let id = this.name.split("//"); //splits the string into pieces
			this.id = id[2];
			const event = await fb.db
				.collection("Events")
				.doc(this.id)
				.get();

			if (event.exists) {
				fb.db
					.collection("Events")
					.doc(this.id)
					.delete()
					.then(() => {
						this.showSuccess = true;
						this.showError = false;
					})
					.catch((error) => {
						this.error = error;
						this.showError = true;
					});
			} else {
				this.error = "You must select a specific document to Delete";
				this.showError = true;
			}
		},
	},
};
</script>
